import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { retry, catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { ComumService } from '../comum/comum.service';
import { Router } from '@angular/router';
import { Evento } from '../comum/eventos/evento';
import { CookieService } from 'angular2-cookie/core';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
    public evento: Evento;

    constructor (private _authService: AuthService,
        private _cookieService: CookieService,
        private _comumService: ComumService,
        private router: Router) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const headers = new HttpHeaders({
            'Authorization': this._cookieService.get('token'),
            'Access-Control-Allow-Origin' : '*'
        });

        const cloneReq = request.clone({ headers });

        return next.handle(cloneReq).pipe(
            retry(1),
            catchError((error) => {
                if (error.status === 401 || error.status === 403) {
                    this._comumService.evento.error = true;
                    this._comumService.evento.unauthorized = true;
                    this.router.navigate(['login']);
                    this._authService.logout();
                } else {
                    return error;
                }
            })
        );
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/auth/auth-token.interceptor.ts